<template>
  <div
    class="inset-0 flex aspect-video h-full w-full items-center justify-center bg-black bg-opacity-50"
  >
    <div class="flex h-full w-full flex-col items-center justify-center gap-2 bg-black p-2">
      <TriangleAlert class="h-10 w-10 fill-grey" />
      <p class="text-balance text-center text-white">
        {{ error || t('common.videoNotAvailable') }}
      </p>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n';
import { TriangleAlert } from 'lucide-vue-next';

interface Props {
  error?: string;
}

defineProps<Props>();

const { t } = useI18n();
</script>
